export const createMockData = <T>(defaultData: T, overrides?: Partial<T>): T => {
  return {
    ...defaultData,
    ...overrides,
    id: generateUID(),
    createdAt: new Date(),
    updatedAt: new Date(),
  };
};

export const generateUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const delay = (ms: number) => 
  new Promise((resolve) => setTimeout(resolve, ms));
